import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Vehicles categories stats DTO
 */
@CaslSubject(AppSubjectEnum.VEHICLE_CATEGORY)
export class VehicleCategoriesStatsDto extends BaseStatsDto {}
